var _style, _g, _g2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgGoogleDeveloperTools(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 126.7",
    style: {
      enableBackground: "new 0 0 500 126.7"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#EA4335;}\r\n\t.st1{fill:#4285F4;}\r\n\t.st2{fill:#34A853;}\r\n\t.st3{fill:#FBBC05;}\r\n\t.st4{fill:#5F6368;}\r\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M86.7,38.8l4.4,0.1l11.9-11.9l0.6-5C76-4.4,25,11,16.7,47.9c2.1-0.1,24.9-3.4,27.8-4.1c0,0,1.2-2,1.8-1.9 C56.8,30.3,74.5,29,86.7,38.8L86.7,38.8z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M119.6,48c-2.7-10-8.3-19-16.1-25.9L86.7,38.8c7.9,6.2,11.7,16.1,11,26c19.4,0.1,19.3,29.5,0,29.6 c0,0-29.6,0-29.6,0l-3,3v17.8l3,2.9h29.6C135,118.8,150.2,68,119.6,48L119.6,48z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M38.5,118.1h29.6V94.4c-4.7-0.4-31.9,1.2-35.7-1.3l-4.3,1.3l-11.9,11.9l-1,4C21.9,115.4,30.1,118.2,38.5,118.1 L38.5,118.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st3",
    d: "M38.5,41.1c-35.9-1.1-52.4,48.4-23.2,69.2l17.2-17.2C8.6,79.7,38.6,49.8,52,73.6l17.2-17.2 C62.1,47.1,51,41.2,38.5,41.1L38.5,41.1z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M204.1,58.4c-15.6,0.4-30.1-13.5-29.6-29.2C173.6,4.5,206.9-9.9,224.1,8l-5.6,5.6 c-20.3-18.6-48.1,11.1-29.2,30.6c10.2,11.1,32.7,6.9,34-9.7h-19.1v-8H231C234.1,43.9,221.7,58.9,204.1,58.4L204.1,58.4z  M266.6,53.1c-18.1,17-44.1-8.9-26.8-26.8C257.8,9.2,283.9,35.1,266.6,53.1z M245.7,47.8c10.3,10.7,24.8-6.7,15-16.4 C250,20.9,236,37.8,245.7,47.8L245.7,47.8z M307.7,53.1c-18.1,17-44.1-8.9-26.8-26.8C299,9.2,325.1,35.1,307.7,53.1z M286.9,47.8 c10.3,10.7,24.8-6.7,15-16.4C291.2,20.9,277.2,37.8,286.9,47.8L286.9,47.8z M334.8,75.3c-7.6,0.2-13.9-4.8-16.7-11.1l7.2-3 c5.7,12.3,21.9,6.5,19.5-7h-0.3c-9.7,11-29-0.8-27.9-14.5c-1-13.8,17.7-25.5,27.9-14.7h0.3v-3h7.8C350.8,38.2,361,75.9,334.8,75.3 L334.8,75.3z M335.4,51c13.3,0.2,13.2-23,0-22.8C321.7,28.1,321.6,51.2,335.4,51L335.4,51z M366.7,2v55.3h-8.3V2H366.7z  M389.3,58.4c-16.6,0.9-24.7-21.4-13.5-32.3c9.6-10.4,26.5-4.3,29.5,8.8l-25.1,10.4c3.4,7.6,14.1,7.5,18.4,0.5l6.4,4.3 C401.6,55,396,58.6,389.3,58.4L389.3,58.4z M378.8,39l16.8-7C391,23.6,377.6,29.9,378.8,39L378.8,39z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M203,101.2c0.6,14.7-12.8,16.2-24.5,15.4V86.4C189.9,85.7,203.3,86.4,203,101.2z M197.8,101.4 c0.4-9.5-6.7-11.5-14.4-10.8v21.9C191.3,113.2,198.2,110.5,197.8,101.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M218.9,117c-11,0.9-14.4-13.5-8.5-20.4c7.7-7.6,19.3-1.2,17.4,9.7h-15.2c-0.2,8,8.7,7.9,14.1,5.2v3.9 C224,116.6,221.8,117,218.9,117z M218,97c-3.4,0-5,2.3-5.4,5.7H223C222.9,99.3,221.4,97,218,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M238.4,116.6l-8.7-22.8h5.1c1.1,3.6,5.7,15.3,6.1,18.7h0.2c0.3-2.8,5-15.4,6.1-18.7h5.2l-8.7,22.8H238.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M265.8,117c-11,0.9-14.4-13.5-8.5-20.4c7.7-7.6,19.3-1.2,17.4,9.7h-15.2c-0.2,8,8.7,7.9,14.1,5.2v3.9 C270.9,116.6,268.7,117,265.8,117z M264.9,97c-3.4,0-5,2.3-5.4,5.7h10.3C269.9,99.3,268.3,97,264.9,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M285,116.6h-4.8V84.5h4.8V116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M312.1,105.1c1,15.9-22.5,15.5-21.6,0C289.2,89.6,313.3,89.7,312.1,105.1z M295.5,105.1 c-0.8,10.6,12.4,10.6,11.6,0C308,94.2,294.3,95.3,295.5,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M329.3,117c-2.9,0-5.1-1-6.7-3.1h-0.3c0.5,3.3,0.2,9.7,0.3,12.8h-4.8V93.8h3.9c0.1,0.4,0.3,1.4,0.7,3h0.2 C337,81.8,346.4,116.2,329.3,117z M328.1,97.3c-7.9-0.9-7.5,16.6,0.1,15.7C335.3,113.1,335.4,97.1,328.1,97.3z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M353.9,117c-11,0.9-14.4-13.5-8.5-20.4c7.7-7.6,19.3-1.2,17.4,9.7h-15.2c-0.2,8,8.7,7.9,14.1,5.2v3.9 C359.1,116.6,356.9,117,353.9,117z M353.1,97c-3.4,0-5,2.3-5.4,5.7H358C358,99.3,356.4,97,353.1,97z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M379.9,93.4c1,0,1.8,0.1,2.4,0.2l-0.5,4.5c-11.2-2.7-8.4,12.1-8.7,18.5h-4.8V93.8h3.8l0.6,4h0.2 C374.4,95.2,377,93.3,379.9,93.4z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M408.4,116.6h-4.9V90.7h-8.9v-4.2h22.6v4.2h-8.9V116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M441.6,105.1c1,15.9-22.5,15.5-21.6,0C418.7,89.6,442.8,89.7,441.6,105.1z M425,105.1 c-0.8,10.6,12.4,10.6,11.6,0C437.4,94.2,423.7,95.3,425,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M467.4,105.1c1,15.9-22.5,15.5-21.6,0C444.4,89.6,468.6,89.7,467.4,105.1z M450.8,105.1 c-0.8,10.6,12.4,10.6,11.6,0C463.2,94.2,449.5,95.3,450.8,105.1z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M477.8,116.6h-4.8V84.5h4.8V116.6z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "st4",
    d: "M500,110.1c0.2,8-11.7,7.9-16.7,5.5v-4.2c3.5,2.1,14,3.6,11.5-2.3c-2.1-2.2-8.6-3.5-10.1-5.6 c-6.1-9.3,8.6-12.4,15-8.5l-1.6,3.6c-3.3-1.4-9.4-3-10,0.7C489.5,104.1,500.8,103.1,500,110.1z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGoogleDeveloperTools);
export default __webpack_public_path__ + "static/media/google-developer-tools.b7c7e7ddab2a5241ced9592b94dae7e7.svg";
export { ForwardRef as ReactComponent };